import { FC } from 'react';

import { PageMetaSeo } from '@/components/page-seo-meta';
import { ISeoWrapperProps } from './seo-wrapper.interface';

const SeoWrapper: FC<ISeoWrapperProps> = ({ seoMetaData, currentUrlBase, jsonLdScript, heroImageUrl, children }) => (
  <>
    <PageMetaSeo 
      currentUrlBase={currentUrlBase} 
      seoMetaData={seoMetaData} 
      jsonLdScript={jsonLdScript}
      heroImageUrl={heroImageUrl || undefined}
    />
    {children}
  </>
);

export default SeoWrapper;
